module.exports = __webpack_public_path__ + "static/img/财务级场景_角标_image@2x.b1647af3.png";